import React, { Component } from 'react';
import { crudActions } from "@sm/services/crudActions";
import Form from "@sm/core/Form";
import { DATA_TYPES } from "@modules/data/ManualInput";

class OtcCashoutUpdateComponent extends Component {
  state = {
    otcCashoutUpdateBaseAccountRowFields: [
      {
        name: "provider",
        label: "Provider",
        fieldType: "input",
        disabled: true,
        flexGrow: "2"
      },
      {
        name: "account",
        label: "Account",
        fieldType: "input",
        disabled: true,
        flexGrow: "2"
      }, {
        name: "fxRate",
        label: "FX rate",
        fieldType: "input",
        disabled: true
      }, {
        name: "requestedBalance",
        label: "Requested Balance",
        fieldType: "input",
        formatValue: true,
        disabled: true,
        flexGrow: "1"
      },
      {
        name: "incomingFunds",
        label: "Inbound Settlement",
        fieldType: "input",
        formatValue: true,
        disabled: true,
        flexGrow: "1"
      }, {
        name: "status",
        label: "Status",
        fieldType: "select",
        getOptions: () => this.getOptionsFromState("statuses"),
        items: "statuses"
      }],
    otcCashoutUpdateGeneralFields: [
      {
        name: "invoice",
        label: "Invoice",
        fieldType: "input",
        flexGrow: "2",
        disabled: true
      },
      {
        name: "currency",
        label: "Currency",
        fieldType: "input",
        disabled: true
      },
      {
        name: "fxPair",
        label: "FX Pair",
        fieldType: "input",
        disabled: true
      }
    ],
    otcCashoutUpdateFormStateRules: [
      {
        name: "currency",
        type: "isString",
        rules: {
          required: true
        },
      },
      {
        name: "fxPair",
        type: "isString",
        rules: {
          required: true,
        },
      },
      {
        name: "status",
        type: "isString",
        rules: {
          required: true,
        },
      },
    ],
    buttonFields:  [{ fieldType: "empty" }, { fieldType: "empty" }, { fieldType: "empty" }, { fieldType: "empty" },
      { fieldType: "button" }]
  };

  componentDidMount() {
    const { statuses } = this.props;
    if (statuses) {
      this.setState({
        statuses: statuses,
      });
    }
  }

  componentDidUpdate(oldProps) {
    const newProps = this.props;
    if (oldProps.statuses.length !== newProps.statuses.length) {
      this.setState({
        statuses: newProps.statuses,
      });
    }
  }

  onSaveDataEntries = () => {
    const { savedData, form, } = this.props;

    const isValid = form.map((elem) => elem.isFormValid()).every(Boolean);
    this.saveValidationUpdate(form, isValid, isValid);

    if (isValid) {
      const data = [];
      form.forEach((elem) => {
        if (elem.account) {
          data.push({
            companyId: savedData.company,
            accountId: elem.accountId,
            invoice: elem.invoice,
            newStatus: elem.status});
        }
      });

      crudActions.put(`v1/incoming/funds`, data)
        .then(() => {
          this.afterSuccessSave("Operation successful.");
        }).catch((err) => {
          this.errorUpdate(err ? err.message : '');
        });
    }
  };

  onChangeFilter = () => {
    const { controls } = this.props;
    const isFormValid = controls.isFormValid();
    this.onChangeValidationUpdate(controls, isFormValid);

    if (isFormValid) {
      crudActions.get(`v1/incoming/funds?accountIds=${controls.accountIds}&companyId=${controls.company}&dates=${controls.date}`).then((response) => {
        const newState =  this.populateOtcCashoutUpdateForm(response, controls);
        Object.assign(newState, {
          showSecondPanel: true,
          loadingDataInput: false,
          lockButton: false,
        });
        this.updateState(newState);
      }).catch((error) => {
        this.errorUpdate(error ? error.message : "");
      });
    }
  };

  populateOtcCashoutUpdateForm = (response, controls) => {
    const { otcCashoutUpdateBaseAccountRowFields, otcCashoutUpdateGeneralFields, otcCashoutUpdateFormStateRules, buttonFields } = this.state;
    const stateForUpdate = {};
    let OTC_CASHOUT_UPDATE = [];
    const otcCashoutUpdateForm = [];
    response.forEach(invoiceInfo => {
      const incomingFunds = invoiceInfo.incomingFunds.map(() => otcCashoutUpdateBaseAccountRowFields);

      OTC_CASHOUT_UPDATE = OTC_CASHOUT_UPDATE.concat(incomingFunds);
      OTC_CASHOUT_UPDATE.push([...otcCashoutUpdateGeneralFields], []);

      invoiceInfo.incomingFunds.forEach(incomingFund => {
        otcCashoutUpdateForm.push(this.getAccountRowOtcCashoutUpdateForm(incomingFund, invoiceInfo.invoice));
      });

      const otcCashoutUpdateFormState = new Form({
        invoice: invoiceInfo.invoice,
        currency: invoiceInfo.currency,
        fxPair: invoiceInfo.fxPair,
      }, otcCashoutUpdateFormStateRules);
      otcCashoutUpdateForm.push(otcCashoutUpdateFormState, new Form());
    });

    Object.assign(stateForUpdate, {
      otcCashoutUpdateForm: otcCashoutUpdateForm
    });
    OTC_CASHOUT_UPDATE.push(buttonFields);
    this.updateField(DATA_TYPES.OTC_CASHOUT_UPDATE, OTC_CASHOUT_UPDATE);
    return stateForUpdate;
  };

  getAccountRowOtcCashoutUpdateForm = (incomingFund, invoice) => {
    const { controls, companiesAccounts, companiesPsps } = this.props;
    const account = companiesAccounts[controls.company].find(item => item.value === Number(incomingFund.accountId));
    return new Form(
      {
        provider: companiesPsps[controls.company].find(item => Number(item.value) === account.pspId).label,
        account: account.label,
        accountId: incomingFund.accountId,
        fxRate: incomingFund.fxRate,
        requestedBalance: parseFloat(incomingFund.requestedBalance).toFixed(2),
        incomingFunds: parseFloat(incomingFund.incomingFundsAmount).toFixed(2),
        invoice: invoice,
        status: incomingFund.status,
      },
      [
        {
          name: "account",
          type: "isString",
          rules: {
            required: true
          },
        },
        {
          name: "fxRate",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "requestedBalance",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "incomingFunds",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "status",
          type: "isString",
          rules: {
            required: true,
          },
        },
      ]
    );
  };
  
  getOptionsFromState = (optionsName) => {
    return this.state[optionsName];
  };

  updateField = (name, value) => {
    this.props.updateField(name, value);
  };

  updateState = (stateForUpdate) => {
    this.props.updateState(stateForUpdate);
  };

  onChangeValidationUpdate = (controls, isFormValid) => {
    this.props.updateStateAfterOnChangeValidation(controls, isFormValid);
  };
  
  saveValidationUpdate = (form, isFormValid, allValid) => {
    this.props.updateStateAfterOnSaveValidation(form, isFormValid, allValid);
  };

  afterSuccessSave = (message) => {
    this.props.updateStateAfterSuccessSave(message);
  };

  errorUpdate = (message) => {
    this.props.showErrorAlert(message);
  };

  render() {
    return <></>;
  };
}

export default OtcCashoutUpdateComponent;